import { ModuleRegistry } from 'react-module-container';
import { BUSINESS_MANAGER_MODULE_ID, BrowserNotificationAPIReturnValue, getModuleRegistryMethodName } from '@wix/browser-notifications-client/types';

export const isBrowserNotificationsClientAvailable = () =>
  !!(ModuleRegistry.getModule(BUSINESS_MANAGER_MODULE_ID));

export const isBrowserNotificationsSupported = (): BrowserNotificationAPIReturnValue<'isBrowserNotificationsSupported'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('isBrowserNotificationsSupported'));

export const getBrowserNotificationsPermission = (): BrowserNotificationAPIReturnValue<'getBrowserNotificationsPermission'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('getBrowserNotificationsPermission'));

export const isRegisteredForBrowserNotifications = (): BrowserNotificationAPIReturnValue<'isRegisteredForBrowserNotifications'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('isRegisteredForBrowserNotifications'));

export const isRegisteredForBrowserNotificationsOnSite = (metaSiteId: string): BrowserNotificationAPIReturnValue<'isRegisteredForBrowserNotificationsOnSite'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('isRegisteredForBrowserNotificationsOnSite'), metaSiteId);

export const registerForBrowserNotifications = (): BrowserNotificationAPIReturnValue<'registerForBrowserNotifications'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('registerForBrowserNotifications'));

export const registerAndTurnOnSite = (metaSiteId: string): BrowserNotificationAPIReturnValue<'registerAndTurnOnSite'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('registerAndTurnOnSite'), metaSiteId);

export const unregisterFromBrowserNotifications = (): BrowserNotificationAPIReturnValue<'unregisterFromBrowserNotifications'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('unregisterFromBrowserNotifications'));

export const registerForBrowserPermissionRequest = (handler: () => void): BrowserNotificationAPIReturnValue<'registerForBrowserPermissionRequest'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('registerForBrowserPermissionRequest'), handler);

export const registerForBrowserPermissionResponse = (handler: () => void): BrowserNotificationAPIReturnValue<'registerForBrowserPermissionResponse'> =>
  ModuleRegistry.invoke(getModuleRegistryMethodName('registerForBrowserPermissionResponse'), handler);
